import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { collapsePrefixCls } from "@/base/components/collapse/Collapse.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Collapse">> = ({
  boxShadow,
  borderRadiusLG,
  colorBorder,
  panelGap,
  contentBg,
  colorTextHeadingIcon,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${collapsePrefixCls}`]: {
      borderColor: "transparent",
      display: "flex",
      flexDirection: "column",
      gap: `${panelGap}px`,
      backgroundColor: "transparent",

      [`.${collapsePrefixCls}-item`]: {
        backgroundColor: contentBg,
        boxShadow: boxShadow,
        borderColor: colorBorder,
        borderRadius: `${borderRadiusLG}px !important`,

        [`.${collapsePrefixCls}-header`]: {
          alignItems: "center",

          [`${`.${collapsePrefixCls}-expand-icon`}`]: {
            color: colorTextHeadingIcon,
          },
        },

        [`.${collapsePrefixCls}-content`]: {
          borderRadius: `0 0 ${borderRadiusLG}px ${borderRadiusLG}px`,
        },
      },
    },
  },
});

export const useCollapseStyle = genComponentStyleHook(
  ["Collapse", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
